import React from "react";
import { motion } from "framer-motion";
import { BottomSheet } from "@/components/ui/bottom-sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface ReturnsExchangeSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const returnsExchangeSections = [
  {
    title: "Return Policy",
    items: [
      {
        question: "What is the return window?",
        answer: "We accept returns within 14 days of delivery, provided the item is in the same condition as received—unworn, unwashed, with original tags attached, and including any accompanying items like the storybook and poster (if applicable)."
      },
      {
        question: "What are the return conditions?",
        answer: "Items must be unworn, unwashed, with original tags attached, and include all accompanying items like the storybook and poster (if applicable). The item must be in the same condition as received."
      },
      {
        question: "Who pays for return shipping?",
        answer: "Customers are responsible for return shipping fees unless the item received is defective or incorrect."
      }
    ]
  },
  {
    title: "Exchange Policy",
    items: [
      {
        question: "How do exchanges work?",
        answer: "Exchanges are possible if the requested size is in stock. If unavailable, you may return the item and place a new order."
      },
      {
        question: "What is the exchange window?",
        answer: "We accept exchanges within 7 days of delivery, subject to the same conditions as returns—items must be unworn, unwashed, with original tags attached."
      }
    ]
  },
  {
    title: "Refund Process",
    items: [
      {
        question: "How are refunds processed?",
        answer: "Refunds will be processed using the same payment method used for the purchase. If you paid by Visa, the refund will be credited to your card. If you paid cash on delivery, you will receive a cash refund."
      }
    ]
  }
];

export function ReturnsExchangeSheet({ isOpen, onClose }: ReturnsExchangeSheetProps) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="p-6"
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold">Returns and Exchange Policy</h2>
        </div>
        <div className="space-y-6">
          <Accordion type="single" collapsible className="w-full">
            {returnsExchangeSections.map((section, index) => (
              <div key={section.title} className="mb-6">
                <h3 className="text-lg font-medium mb-4">{section.title}</h3>
                {section.items.map((item, itemIndex) => (
                  <AccordionItem key={itemIndex} value={`${index}-${itemIndex}`}>
                    <AccordionTrigger className="text-left">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent>{item.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </div>
            ))}
          </Accordion>
        </div>
      </motion.div>
    </BottomSheet>
  );
} 